<template>
    <section class="main-content home-page pb-5">
        <div v-if="typeof getAnnouceRecord !== 'undefined'">
            <ModalX
                :showModal="showModal"
                :input="getAnnouceRecord"
                @closedModal="onClosedModal"
            />
        </div>

        <div class="announce-bar" v-if="marquee_text">
            <div class="announce-bar__inner">
                <span class="announce-bar__label">
                    <i class="fa fa-bullhorn"></i>
                    ประกาศ
                </span>
                <div class="announce-bar__ticker">
                    <div class="announce-bar__track">
                        <span>{{ marquee_text }}</span>
                        <span>{{ marquee_text }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="content__lotto">
                <section class="wallet-card my-2">
                    <div class="wallet-card__content">
                        <div class="wallet-card__glow wallet-card__glow--top"></div>
                        <div class="wallet-card__glow wallet-card__glow--bottom"></div>

                        <div class="wallet-card__top">
                            <div class="wallet-card__welcome">
                                <span class="wallet-card__greeting">ยินดีต้อนรับ</span>
                                <span class="wallet-card__username">{{ userName }}</span>
                            </div>
                        </div>

                        <div class="wallet-card__balance-block">
                            <div class="wallet-card__label">
                                <i class="fa fa-wallet"></i>
                                ยอดเงินคงเหลือ
                            </div>
                            <div class="wallet-card__balance">
                                <span class="wallet-card__currency">฿</span>
                                <span>{{ calculateUserBalance }}</span>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="action-grid row no-gutters">
                    <div class="col-sm-6 col-xs-6 deposit-div px-1">
                        <router-link
                            :to="{ name: 'deposit' }"
                            class="action-btn action-btn--primary btn btn-block mb-2"
                        >
                            <span class="action-btn__icon">
                                <i class="fa fa-plus-circle"></i>
                            </span>
                            <span class="action-btn__text-wrap">
                                <span class="action-btn__title">ฝากเครดิต</span>
                                <span class="action-btn__subtitle">เติมเงินเข้าระบบ</span>
                            </span>
                        </router-link>
                    </div>

                    <div class="col-sm-6 col-xs-6 withdraw-div px-1">
                        <router-link
                            :to="{ name: 'withdraw' }"
                            class="action-btn action-btn--secondary btn btn-block mb-2"
                        >
                            <span class="action-btn__icon">
                                <i class="fa fa-minus-circle"></i>
                            </span>
                            <span class="action-btn__text-wrap">
                                <span class="action-btn__title">ถอนเครดิต</span>
                                <span class="action-btn__subtitle">ถอนเงินออก</span>
                            </span>
                        </router-link>
                    </div>
                </div>

                <section class="features" id="features">
                    <div class="feature-container">
                        <div
                            v-for="(feature, idx) in features"
                            :key="idx"
                            class="feature-div"
                        >
                            <a
                                v-if="feature.link.name == 'information'"
                                :href="line_contact"
                                class="feature-link"
                                target="_blank"
                            >
                                <div class="feature-item">
                                    <div class="feature-icon-wrap">
                                        <i :class="feature.icon_class">{{ feature.icon_label || '' }}</i>
                                    </div>
                                    <h5>{{ feature.label }}</h5>
                                </div>
                            </a>

                            <b-link
                                v-else
                                :to="feature.link"
                                class="feature-link"
                            >
                                <div class="feature-item">
                                    <div class="feature-icon-wrap">
                                        <i :class="feature.icon_class">{{ feature.icon_label || '' }}</i>
                                    </div>
                                    <h5>{{ feature.label }}</h5>
                                </div>
                            </b-link>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <SupportFab to="/chat" />
    </section>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import ModalX from './ModalPopup'
import SupportFab from '@/components/SupportFab/SupportFab.vue'

export default {
    name: "home",
    components: {
        ModalX,
        SupportFab
    },
    data() {
        return {
            userBalance: 0,
            userName: '',
            site_name: '',
            line_contact: '',
            marquee_text: 'เว็บหวยออนไลน์ที่ดีที่สุด ยินดีต้อนรับค่ะ',
            features: [
                {
                    link: {
                        name: "lottery"
                    },
                    label: "แทงหวย",
                    icon_class: "icofont-dice-multiple",
                    icon_label: ""
                },
                {
                    link: {
                        name: "transaction"
                    },
                    label: "รายการโพย",
                    icon_class: "icofont-prescription",
                    icon_label: ""
                },
                {
                    link: {
                        name: "lottoresultbydate"
                    },
                    label: "ดูผลรางวัล",
                    icon_class: "icofont-bullhorn",
                    icon_label: ""
                },
                {
                    link: {
                        name: "reqcredit"
                    },
                    label: "แจ้งฝาก/ถอน",
                    icon_class: "icofont-bank",
                    icon_label: ""
                },
                {
                    link: {
                        name: "credit"
                    },
                    label: "รายงานเครดิต",
                    icon_class: "icofont-chart-growth",
                    icon_label: ""
                },
                {
                    link: {
                        name: "affiliate"
                    },
                    label: "ลิงค์หารายได้",
                    icon_class: "icofont-users-alt-1",
                    icon_label: ""
                },
                {
                    link: {
                        name: "numberset"
                    },
                    label: "สร้างเลขชุด",
                    icon_class: "icofont-ui-copy",
                    icon_label: ""
                },
                {
                    link: {
                        name: "information"
                    },
                    label: "ติดต่อแอดมิน",
                    icon_class: "icofont-live-support",
                    icon_label: ""
                },
                {
                    link: {
                        name: "helpcenter"
                    },
                    label: "วิธีใช้งาน",
                    icon_class: "icofont-ui-text-chat",
                    icon_label: ""
                }
            ],
            showModal: true
        }
    },
    mounted() {
        if (this.user) {
            this.userName = this.user.username
            this.site_name = process.env.VUE_APP_SITE

            if (this.lineContact.link) {
                this.line_contact = this.lineContact.link
            } else {
                this.loadLineContact()
            }

            if (typeof this.getMarqueeText !== 'undefined') {
                this.marquee_text = this.getMarqueeText.header
            }

            if (this.$Tawk) {
                this.$Tawk.$showWidget()
                this.updateTawkUser()
            }
        }
    },
    methods: {
        async loadUserBalance() {
            if (!this.user) {
                return
            }

            try {
                const response = await this.$store.dispatch(
                    "ledger/getUserBalance",
                    this.user.account_id
                )

                if (response.balance) {
                    this.userBalance = this.formatMoney(response.balance.toFixed(2))
                } else {
                    this.userBalance = 0.0
                }

                return this.userBalance
            } catch (error) {
                this.$toasted.error(
                    "There was an error connecting to the server."
                )
                this.$store.dispatch('user/userLogout')
            }
        },
        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },
        onClosedModal() {
            this.showModal = false
        },
        updateTawkUser() {
            try {
                let user = {
                    name: this.user.username,
                    email: this.user.username + '@tempmail.com',
                }

                this.$Tawk.$updateChatUser(user)
            } catch (error) {
                console.log("updateTawkUser error: ", error)
            }
        },
        async loadLineContact() {
            try {
                const response = await this.$store.dispatch('information/getLineContact')
                this.line_contact = response.link
            } catch (error) {
                console.log('error', error)
            }
        },
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            informations: state => state.information.informations,
            lineContact: state => state.information.lineContact,
        }),
        ...mapGetters('information', ['getInformationCount', 'getAnnouceRecord', 'getMarqueeText']),
        calculateUserBalance: function() {
            this.loadUserBalance()
            return this.userBalance
        }
    },
    async created() {
        try {
            await this.$store.dispatch('information/getInfotmation')
        } catch (e) {
            console.log(e)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/components/_global.scss";

.home-page {
    background:
        radial-gradient(circle at top left, rgba(46, 125, 50, 0.05), transparent 25%),
        linear-gradient(180deg, #f6f8f6 0%, #eef2ee 100%);
    min-height: 100vh;
    padding-top: 14px;
}

.content__lotto {
    padding: 0;
}

.announce-bar {
    background: transparent;
    margin-bottom: 14px;
    padding: 8px 12px 0;
}

.announce-bar__inner {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(46, 125, 50, 0.12);
    border-radius: 16px;
    padding: 7px 10px;
    box-shadow: 0 10px 24px rgba(15, 84, 19, 0.06);
    overflow: hidden;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
}

.announce-bar__label {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #1f6d2d;
    font-weight: 800;
    font-size: 13px;
    white-space: nowrap;
}

.announce-bar__ticker {
    position: relative;
    overflow: hidden;
    width: 100%;
}

.announce-bar__track {
    display: inline-flex;
    align-items: center;
    gap: 48px;
    min-width: max-content;
    animation: ticker-scroll 18s linear infinite;
    color: #d32f2f;
    font-size: 14px;
    font-weight: 700;
}

.wallet-card {
    margin-bottom: 14px !important;
}

.wallet-card__content {
    position: relative;
    overflow: hidden;
    padding: 18px 16px;
    border-radius: 22px;
    min-height: 190px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // background: linear-gradient(135deg, #2e7d32 0%, #16611e 48%, #0f5413 100%);
    background: linear-gradient(135deg, #1A4F4B 0%, #235E59 50%, #2A6E6B 100%);
    box-shadow:
        0 18px 38px rgba(15, 84, 19, 0.16),
        inset 0 1px 0 rgba(255, 255, 255, 0.08);
    color: #fff;
}

.wallet-card__glow {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
}

.wallet-card__glow--top {
    top: -32px;
    right: -24px;
    width: 170px;
    height: 170px;
    background: rgba(255, 255, 255, 0.08);
}

.wallet-card__glow--bottom {
    bottom: -46px;
    left: -26px;
    width: 120px;
    height: 120px;
    background: rgba(255, 255, 255, 0.06);
}

.wallet-card__top,
.wallet-card__balance-block {
    position: relative;
    z-index: 1;
}

.wallet-card__top {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.wallet-card__welcome {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.wallet-card__greeting {
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.88);
}

.wallet-card__username {
    display: inline-flex;
    align-self: flex-start;
    align-items: center;
    min-height: 38px;
    // background: linear-gradient(135deg, #ffd54f 0%, #fbc02d 100%);
    background: #A7D8DB;
    color: #1f2a1f;
    font-size: 14px;
    font-weight: 800;
    line-height: 1;
    border-radius: 999px;
    padding: 0 16px;
    box-shadow: 0 8px 20px rgba(251, 192, 45, 0.22);
}

.wallet-card__label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.92);
    margin-bottom: 10px;
    font-weight: 700;
}

.wallet-card__balance {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    line-height: 1;
    font-size: 34px;
    font-weight: 800;
    letter-spacing: -0.5px;
    word-break: break-word;
}

.wallet-card__currency {
    font-size: 22px;
    transform: translateY(-2px);
    opacity: 0.95;
}

.action-grid {
    margin-bottom: 14px;
}

.action-btn {
    width: 100%;
    min-height: 72px;
    border-radius: 18px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-decoration: none !important;
    transition: all 0.2s ease;
    border-width: 1.5px;
    box-shadow: 0 10px 24px rgba(15, 84, 19, 0.08);
    padding: 10px 12px;
}

.action-btn:hover,
.action-btn:focus {
    transform: translateY(-1px);
}

.action-btn__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 12px;
    font-size: 20px;
    line-height: 1;
    flex: 0 0 38px;
}

.action-btn__text-wrap {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    text-align: left;
}

.action-btn__title {
    font-size: 17px;
    font-weight: 800;
    line-height: 1.1;
}

.action-btn__subtitle {
    font-size: 11px;
    font-weight: 600;
    opacity: 0.82;
    line-height: 1.2;
}

.action-btn--primary {
    // color: #fff;
    color: #D0B06B;
    border-color: transparent;
    // background: linear-gradient(135deg, #2e7d32 0%, #0f5413 100%) !important;
    background: linear-gradient(135deg, #1A4F4B 0%, #235E59 50%, #2A6E6B 100%) !important;
}

.action-btn--primary .action-btn__icon {
    background: rgba(255, 255, 255, 0.16);
    // color: #fff;
    color: #D0B06B;
}

.action-btn--primary:hover,
.action-btn--primary:focus {
    color: #fff;
}

.action-btn--secondary {
    // color: #2e7d32;
    // background: rgba(255, 255, 255, 0.95);
    // border-color: rgba(46, 125, 50, 0.25);
    color: #3A2800;
    border-color: transparent;
    background: linear-gradient(135deg, #8B6914 0%, #C9A23A 40%, #E8CC72 65%, #C4972A 100%) !important;
}

.action-btn--secondary .action-btn__icon {
    background: rgba(46, 125, 50, 0.1);
    // color: #2e7d32;
    color: #5C3D00;
}

.action-btn--secondary:hover,
.action-btn--secondary:focus {
    color: #1b5e20;
    border-color: #1b5e20;
    background: #fff;
}

.feature-container {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}

.feature-div {
    min-width: 0;
}

.feature-link {
    display: flex !important;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 136px;
    text-decoration: none !important;
    background: rgba(255, 255, 255, 0.96);
    // border: 1px solid rgba(46, 125, 50, 0.08);
    border: 1px solid #2A6E68;
    border-radius: 22px;
    box-shadow:
        0 10px 24px rgba(15, 84, 19, 0.05),
        inset 0 1px 0 rgba(255, 255, 255, 0.85);
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
    overflow: hidden;
}

.feature-link:hover .feature-icon-wrap,
.feature-link:focus .feature-icon-wrap {
    transform: translateY(-2px) scale(1.04);
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.90),
        0 12px 22px rgba(21, 77, 26, 0.10);
}

.feature-link:hover .feature-item i,
.feature-link:focus .feature-item i {
    transform: scale(1.05);
}
.feature-link:active {
    transform: translateY(-1px) scale(0.98);
}

.feature-item {
    width: 100%;
    padding: 16px 10px 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    text-align: center;
}

.feature-icon-wrap {
    width: 62px;
    height: 62px;
    border: 1px solid #2A6E68;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
        180deg,
        rgba(237, 242, 237, 1) 0%,
        rgba(228, 235, 229, 1) 100%
    );
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.85),
        0 8px 18px rgba(21, 77, 26, 0.05);
    transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.feature-item i {
    font-size: 30px;
    line-height: 1;
    // color: #2e7d32;
    color: #2A6E68;
    transition: transform 0.18s ease, color 0.18s ease;
    animation: none !important;
}

.feature-item h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 800;
    line-height: 1.35;
    // color: #1d6b2b;
    color: #1D5E5A;
    white-space: normal;
    word-break: break-word;
}

.mb-2,
.my-2 {
    margin-bottom: 0.5rem !important;
}

@keyframes ticker-scroll {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

@media (max-width: 767px) {
    .announce-bar {
        padding: 8px 8px 0;
    }

    .announce-bar__inner {
        padding: 10px 12px;
        gap: 10px;
        border-radius: 14px;
    }

    .announce-bar__label {
        font-size: 12px;
    }

    .announce-bar__track {
        font-size: 13px;
    }

    .wallet-card__content {
        min-height: 170px;
        padding: 16px 14px;
        border-radius: 20px;
    }

    .wallet-card__balance {
        font-size: 30px;
    }

    .wallet-card__currency {
        font-size: 20px;
    }

    .action-btn {
        min-height: 66px;
        font-size: 16px;
        border-radius: 16px;
        gap: 8px;
    }

    .action-btn__icon {
        width: 34px;
        height: 34px;
        flex-basis: 34px;
        font-size: 18px;
    }

    .action-btn__title {
        font-size: 15px;
    }

    .action-btn__subtitle {
        font-size: 10px;
    }

    .feature-link {
        min-height: 128px;
        border-radius: 20px;
    }

    .feature-icon-wrap {
        width: 56px;
        height: 56px;
        border-radius: 18px;
    }

    .feature-item i {
        font-size: 27px;
    }

    .feature-item h5 {
        font-size: 13px;
    }
}

@media (min-width: 768px) {
    .feature-container {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .wallet-card__content {
        min-height: 210px;
        padding: 22px 20px;
    }

    .wallet-card__balance {
        font-size: 42px;
    }
}

@media (min-width: 1200px) {
    .feature-container {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .feature-link {
        min-height: 148px;
    }
}
</style>